module.exports={object:require("./object"),array:require("./array"),regex:require("./regexp")};